export default __webpack_public_path__ + "static/media/logo1.7d2d5ab3.png";